export const footerLinks = [
	{
		hrefs: { 
               default: "/politica-de-confidentialitate", 
               en: "/politica-de-confidentialitate/en",
               fr: "/politica-de-confidentialitate/fr",
               it: "/politica-de-confidentialitate/it",
               de: "/politica-de-confidentialitate/de",
          },
		key: "politica_de_confidentialitate",
	},
	{
		hrefs: {
			default: "/termeni-si-conditii",
			en: "/termeni-si-conditii/en",
			fr: "/termeni-si-conditii/fr",
			it: "/termeni-si-conditii/it",
			de: "/termeni-si-conditii/de",
		},
		key: "termeni_si_conditii",
	},
	{
		hrefs: {
			default: "/termeni-si-conditii#15",
			en: "/termeni-si-conditii/en#15",
			fr: "/termeni-si-conditii/fr#15",
			it: "/termeni-si-conditii/it#15",
			de: "/termeni-si-conditii/de#15",
		},
		key: "prelucrearea_datelor_cu_caracter_personal",
	},
	{
		hrefs: { default: "/sitemap" },
		key: "sitemap",
	},
	{
		hrefs: { 
               default: "/politica-cookies", 
               en: "/politica-cookies/en",
               fr: "/politica-cookies/fr",
               it: "/politica-cookies/it",
               de: "/politica-cookies/de",
          },
		key: "politica_cookies",
	},
     {
		hrefs: { 
               default: "/termeni-si-conditii#11", 
               en: "/termeni-si-conditii/en#11",
               fr: "/termeni-si-conditii/fr#11",
               it: "/termeni-si-conditii/it#11",
               de: "/termeni-si-conditii/de#11",
          },
		key: "livrare",
	},
];

export const aboutLinks = [
	{ hrefs: { default: "/formular-retur" }, key: "formular_retur" },
	{ hrefs: { default: "/autentificare" }, key: "autentificare" },
	{ hrefs: { default: "/inregistrare" }, key: "inregistrare" },
	{ hrefs: { default: "https://anpc.ro/" }, key: "anpc" },
	{ hrefs: { default: "https://anpc.ro/?ref=footer_3_6" }, key: "anpc2" },
	{ hrefs: { default: "https://anpc.ro/ce-este-sal/?ref=footer_3_5" }, key: "anpc3" },
	{
		hrefs: {
			default: "/termeni-si-conditii#14",
			en: "/termeni-si-conditii/en#14",
			fr: "/termeni-si-conditii/fr#14",
			it: "/termeni-si-conditii/it#14",
			de: "/termeni-si-conditii/de#14",
		},
		key: "14_zile_retur",
	},
];

export const paymentImages = [
	{ src: "/images/netopia.webp", width: 200, height: 38, alt: "", href: "https://netopia-payments.com/" },
	{ src: "/images/logo/trust.webp", width: 48, height: 41, alt: "", href: "" },
	{ src: "/images/logo/trust_2025.webp", width: 80, height: 57, alt: "", href: "" },
	{ src: "/images/logo/gdpr.webp", width: 40, height: 40, alt: "", href: "https://gdprcomplet.ro/" },
	{ src: "/anpc-sal.svg", width: 202, height: 50, alt: "", href: "https://reclamatiisal.anpc.ro/" },
	{
		src: "/anpc-sol.svg",
		width: 202,
		height: 50,
		alt: "",
		href: "https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=RO",
	},
];
